import { getClients } from '@/api/client';
import { useState, useEffect } from 'react';

interface useClientsProps {
  searchTerm?: string;
  status?: string; // Add status parameter
}

interface ClientsData {
  clients: Client[];
  loading: boolean;
  handleRefresh: () => void;
  loadMore: () => void;
}

const useClientsInfinitScroll = ({
  searchTerm,
  status,
}: useClientsProps = {}): ClientsData => {
  const [clients, setClients] = useState<Client[]>([]);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [hasMore, setHasMore] = useState<boolean>(true);

  const handleRefresh = () => {
    setClients([]);
    setPage(1);
    setRefresh(!refresh);
  };

  const loadMore = () => {
    if (loading || !hasMore) return;
    setPage((prevPage) => prevPage + 1);
  };

  useEffect(() => {
    const fetchClients = async () => {
      setLoading(true);
      try {
        const response = await getClients({ page, searchTerm });

        if (page === 1) {
          setClients(response.data);
        } else {
          setClients((prevClients) => [...prevClients, ...response.data]);
        }
        setHasMore(page < response.meta.lastPage);
      } catch (error) {
        console.error('Error fetching Clients:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchClients();
  }, [refresh, searchTerm, status, page]);

  return { clients, handleRefresh, loading, loadMore };
};

export default useClientsInfinitScroll;
